const basePath = "infrastructure-environmental-systems/";

export const physicalSecurity = {
  id: 12,
  category: "Physical Security & Safety",

  filters: {
    Brand: { type: "checkbox" },
    Type: { type: "checkbox" },
    Features: { type: "checkbox" },
    Standards: { type: "checkbox" },
    Resolutions: { type: "checkbox" },
    Agents: { type: "checkbox" },
    Capacity: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "Biometric Door Access Systems",
      bestSeller: false,
      image: `${basePath}Biometric_Door_Access_Systems.png`,
      details: {
        Brand: "Bosch/Salto/Kaba",
        Type: "Fingerprint/Iris/Facial Recognition",
        Features: "IP-based, audit logging",
      },
      about: `
        <ul>
          <li>Advanced biometric door locks for restricted data center and server room access.</li>
          <li>Provide detailed access logs and multi-factor authentication options.</li>
        </ul>
      `,
    },
    {
      name: "Smart Card Readers",
      bestSeller: false,
      image: `${basePath}Smart_Card_Readers.png`,
      details: {
        Brand: "Gemalto/Thales/HID",
        Type: "Contact/Contactless Card Reader",
        Standards: "ISO 7810/ISO 14443",
        Features: "Network-connected, logging",
      },
      about: `
        <ul>
          <li>Card-based access control for data center doors and physical infrastructure.</li>
          <li>Integrate with centralized access management systems.</li>
        </ul>
      `,
    },
    {
      name: "Mantraps / Security Vestibules",
      bestSeller: false,
      image: `${basePath}Mantraps___Security_Vestibules.png`,
      details: {
        Brand: "Salto/Kaba/Tyco",
        Type: "Two-Door Interlocked Access",
        Features: "Mantrap logic, video integration",
      },
      about: `
        <ul>
          <li>Double-door interlocked security vestibules for high-security facility access.</li>
          <li>Prevent tailgating and ensure only authorized personnel enter.</li>
        </ul>
      `,
    },
    {
      name: "CCTV Cameras (IP/Analog)",
      bestSeller: true,
      image: `${basePath}CCTV_Cameras_IP_Analog.webp`,
      details: {
        Brand: "Axis/Hikvision/Uniview",
        Type: "PTZ / Fixed IP Camera",
        Resolutions: "1080p to 4K",
        Features: "Night vision, metadata recording",
      },
      about: `
        <ul>
          <li>IP-based surveillance cameras for data center and facility monitoring.</li>
          <li>Support motion detection, recording integration, and remote viewing.</li>
        </ul>
      `,
    },
    {
      name: "Motion & Environmental Sensors",
      bestSeller: false,
      image: `${basePath}Motion_&_Environmental_Sensors.png`,
      details: {
        Brand: "Bosch/Honeywell/Siemens",
        Type: "PIR Motion / Temp / Humidity / Water Leak",
        Standards: "Wireless/Hardwired",
        Features: "Real-time alerts, integration",
      },
      about: `
        <ul>
          <li>Environmental sensors for temperature, humidity, water ingress, and motion detection.</li>
          <li>Integrate with DCIM and facility management systems for automated alerts.</li>
        </ul>
      `,
    },
    {
      name: "Fire Suppression Systems (FM200/NOVEC)",
      bestSeller: false,
      image: `${basePath}Fire_Suppression_Systems_(FM200_NOVEC).png`,
      details: {
        Brand: "Ansul/Kidde/Tyco",
        Type: "Gaseous Fire Suppression",
        Agents: "FM200 (HFC-227ea) / NOVEC 1230",
        Features: "No residue, electrically safe",
      },
      about: `
        <ul>
          <li>Clean-agent fire suppression systems safe for electronic equipment.</li>
          <li>FM200 and NOVEC leave no residue; EPA phase-out considerations apply.</li>
        </ul>
      `,
    },
    {
      name: "Smoke Detectors",
      bestSeller: true,
      image: `${basePath}Smoke_Detectors.svg`,
      details: {
        Brand: "Honeywell/Hochiki/Apollo",
        Type: "Optical / Ionization",
        Standards: "NFPA 72 / UL Listed",
        Features: "Early warning, addressable",
      },
      about: `
        <ul>
          <li>Smoke detection systems integrated with fire alarm and facility management.</li>
          <li>Provide early warning for fire emergency response.</li>
        </ul>
      `,
    },
    {
      name: "Fire Extinguishers (Type A/B/C)",
      bestSeller: true,
      image: `${basePath}Fire_Extinguishers_(Type_A_B_C).png`,
      details: {
        Brand: "Kidde/Ansul/Badger",
        Type: "ABC Multi-Purpose / CO2",
        Capacity: "5-20 lbs standard",
        Features: "Wall-mounted, regularly certified",
      },
      about: `
        <ul>
          <li>Portable fire extinguishers for emergency response in data centers and server rooms.</li>
          <li>CO2 extinguishers preferred for electrical equipment to avoid residue damage.</li>
        </ul>
      `,
    },
  ],
};
